import React from 'react';
import { CircularProgress, Backdrop } from '@mui/material';
import { themes } from 'theme/themes';
import { brandingInfo } from 'features/server/brandingSlice';
import { useSelector } from 'react-redux';

const Loader: React.FC = () => {
  const branding = useSelector(brandingInfo);
  const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
  return (
    <Backdrop
      sx={{ 
        color: '#fff', 
        // zIndex: (theme) => theme.zIndex.drawer + 1,
        // position: 'absolute',
        // top: 0,
        // left: 0,
        // width: '100%',
        // height: '100%',
        background: 'rgba(0, 0, 0, 0.1)'
      }}
      open={true}
    >
      <CircularProgress sx={{ color: themeColors?.primary }} />
    </Backdrop>
  );
};

export default Loader;